import {
  utils
} from "@utils/utils";
import {
  mainApi
} from '@main/services';
import {
  accountApi
} from "@user-center/account/services";
import {
  SUPPERADMIN
} from "@common/constant";
const state = {
  userInfo: {
    id: ''
  },
  leftMenuData: [],
  systemType: '',
  menuTitle: '',
  menuSelect: '',
  baseInfo: null,
  accountType: '',
  planTypeList: [],
  visitorFirstLogin: localStorage.getItem('visitorFirstLogin') || false, //访客身份初次登录
  whiteListSign: [],
};
const getters = {
  planTypeList: state => state.planTypeList,
  userInfo: state => state.userInfo,
  userName: state => state.userInfo.userName,
  userId: state => state.userInfo.id,
  userCode: state => state.userInfo.userCode,
  isSupperAdmin: state => {
    return state.userInfo.userCode === SUPPERADMIN
  },
  baseInfo: state => state.baseInfo,
  accountType: state => state.accountType,
  btnPerssionMap: state => {
    let returnPerssionMap = {};
    state.leftMenuData.forEach((item, index) => {
      if (!item.children) {
        let tempPath = '/' + item.name;
        returnPerssionMap[tempPath] = item;
        return
      }
      if (item.children) {
        //页面路由
        item.children &&
          item.children.forEach((pageItem, index) => {
            let tempPath = '/' + item.path + '/' + pageItem.name;
            returnPerssionMap[tempPath] = pageItem;
          });
      }
    });
    return returnPerssionMap;
  }
};
const mutations = {
  setUserInfo(state, obj) {
    state.userInfo = obj;
  },
  setIsJoinPlan(state, obj) {
    state.planTypeList = obj;
  },
  setleftMenuData(state, obj) {
    state.leftMenuData = obj;
  },
  setMenuTitle(state, obj) {
    state.menuTitle = obj;
  },
  setMenuSelect(state, obj) {
    state.menuSelect = obj
  },
  setbaseInfo(state, obj) {
    state.baseInfo = obj;
  },
  setAccountType(state, obj) {
    state.accountType = obj
  },
  setVisitorFirstLogin(state, value) {
    state.visitorFirstLogin = value
  },
  setwhitelist(state, obj) {
    let urlMap = []
    obj.forEach(item => { urlMap.push(item.configValue) });
    state.whiteListSign = urlMap;
  },
};
const actions = {
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      Promise.all([
        mainApi.mainQueryUserInfo(state.token),
        mainApi.listwhitelistsign()
      ]).then((resArr) => {
        if (resArr[0].result) {
          const {
            obj
          } = resArr[0];
          if (obj) {
            // 场景1：若是主账号或子账号（渠道管理员），才有权限访问，否则无法分配此权限
            // obj.isMasterAdmin = obj.partnerPostion == "0" || obj.isMaster
            // 场景2：若是子账号，并且是客户经理：1，客户经理主管：2，财务专员：3，按钮没操作权限
            if (obj.partnerPostion == "1" || obj.partnerPostion == "2" || obj.partnerPostion == "3") {
              obj.hideBtnOpt = false
            } else {
              obj.hideBtnOpt = true
            }
            // 用户登录后拉取用户信息：sensors.login(partnerCode-userCode) 
            if (sensors) {
              sensors.login(`${obj.partnerCode}-${obj.userCode}`)
            }
            commit("setUserInfo", obj);
            utils.setLoginSuccess();
          }
        }

        if (resArr[1].result) {
          const objOther = resArr[1].obj;
          if (objOther) {
            commit("setwhitelist", objOther);
          }
        }

        resolve({});
      })
        // mainApi
        //   .mainQueryUserInfo(state.token)
        //   .then(response => {
        //     if (response.result) {
        //       const {
        //         obj
        //       } = response;
        //       if (obj) {
        //         // 场景1：若是主账号或子账号（渠道管理员），才有权限访问，否则无法分配此权限
        //         // obj.isMasterAdmin = obj.partnerPostion == "0" || obj.isMaster
        //         // 场景2：若是子账号，并且是客户经理：1，客户经理主管：2，财务专员：3，按钮没操作权限
        //         if(obj.partnerPostion == "1" || obj.partnerPostion ==  "2" || obj.partnerPostion == "3"){
        //           obj.hideBtnOpt = false
        //         } else {
        //           obj.hideBtnOpt = true
        //         }
        //          // 用户登录后拉取用户信息：sensors.login(partnerCode-userCode) 
        //         if(sensors){
        //           sensors.login(`${obj.partnerCode}-${obj.userCode}`)
        //         }
        //         commit("setUserInfo", obj);
        //         utils.setLoginSuccess();
        //       }
        //     }
        //     resolve({});
        //   })
        .catch(error => {
          reject(error);
        });
    });
  },
  queryBaseInfo({
    commit,
    state,
  }) {
    return accountApi.clientQueryBaseInfo(state.userInfo.id).then(res => {
      if (res && res.result) {
        commit('setbaseInfo', res.obj)
        return res.obj
      }
    });
  },
  // 是否加入伙伴计划
  queryPartenrStatus({
    commit
  }) {
    return mainApi.queryPartenrStatus().then(res => {
      if (res && res.result) {
        if (res.obj) {
          let typeList = res.obj.typeList || {}
          commit('setIsJoinPlan', typeList)
        }
      }
    });
  },
  //查询用户类型 0:主账号 1:子账号
  queryAccountType({
    commit
  }) {
    return accountApi.queryAccountType().then(res => {
      if (res && res.result) {
        if (res.obj) {
          commit('setAccountType', res.obj.accountType)
        }
      }
    });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/modules/main/vuex.js